<mg-report-table
  matSort
  statusReference="flex"
  [dataSourceService]="ds"
  [spaceAfterContent]="true"
  (matSortChange)="ds.sort($event)">
  <mg-role-column [datasource]="ds"></mg-role-column>
  <mg-history-column [datasource]="ds"></mg-history-column>
</mg-report-table>
